import React, { useState } from "react";
import { useEffect } from "react";
import { BsCalendar3 } from "react-icons/bs";
import { ImLink } from "react-icons/im";
import { MdLocationOn } from "react-icons/md";
import getDate from "../../utils/getDate";
import Avatar from "../avatar/Avatar";
import EditBtn from "../button/EditBtn";
import FollowBtn from "../button/FollowBtn";
import LogoutBtn from "../button/LogoutBtn";
import { MessageBtn } from "../button/MessageBtn";
import { useTranslation } from "react-i18next";
import "./UserCard.css";
import { useDispatch, useSelector } from "react-redux";
import { suspendVisitedProfile } from "../../redux/actions/visitedProfileActions";
import {
  IonAvatar,
  IonButton,
  IonContent,
  IonHeader,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
  useIonAlert,
  useIonRouter,
  useIonToast,
} from "@ionic/react";
import { deleteUser } from "../../api/requests/profile";
// export const mutualFollows = (followers, following) => {
//   const followerIds = new Set(followers.map((user) => user._id));
//   return following.filter((user) => followerIds.has(user._id));
// };
export const mutualFollows = (followers = [], following = []) => {
  const getId = (user) => (typeof user === "string" ? user : user?._id);

  const followerIds = new Set(followers.map(getId).filter(Boolean));

  return following.filter((user) => followerIds.has(getId(user)));
};
function ProfileCard({ profile, currentProfile }) {
  const { t } = useTranslation();
  const {
    username,
    avatar,
    banner,
    followers,
    following,
    createdAt,
    city,
    province,
  } = profile;
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentProfile.data);

  const mutualFollowsLength = mutualFollows(followers, following).length;
  const [presentAlert] = useIonAlert();
  const [presentToast] = useIonToast();
  const [openSheet, setOpenSheet] = useState(false);
  const [sheetType, setSheetType] = useState("followers");

  const mutualUsers = mutualFollows(followers, following);

  const sheetUsers =
    sheetType === "followers"
      ? followers
      : sheetType === "following"
        ? following
        : mutualUsers;
  const router = useIonRouter();
  const handleDeleteUser = () => {
    presentAlert({
      header: "Delete Account",
      message: `Are you sure you want to permanently delete @${username}? This action cannot be undone.`,
      buttons: [
        { text: "Cancel", role: "cancel" },
        {
          text: "Delete",
          role: "destructive",
          handler: async () => {
            const response = await deleteUser(username);

            if (response.status === 200 || response.status === 204) {
              presentToast({
                message: "User deleted successfully",
                duration: 2000,
                color: "success",
              });
              router.push("/"); // Navigate to home page
            } else {
              presentToast({
                message: "Failed to delete user",
                duration: 2000,
                color: "danger",
              });
            }
          },
        },
      ],
    });
  };
  const openUserSheet = (type) => {
    setSheetType(type);
    setOpenSheet(true);
  };
  return (
    <>
      <div className="profile-card">
        <div className="profile-card__banner">
          <img src={banner} alt="banner" />
        </div>
        {profile.suspended && (
          <div
            style={{
              backgroundColor: "#ff4d4f",
              color: "white",
              textAlign: "center",
              padding: "10px",
              fontWeight: "bold",
            }}
          >
            This account has been suspended
          </div>
        )}
        <div className="profile-card__bio">
          <div className=" display-flex align-items-c justify-content-sb">
            <div className="profile-card__bio--img display-flex justify-content-c align-items-c">
              <Avatar
                size="lg"
                username={username}
                avatar={avatar}
                province={province}
                isProfilePage={true}
                isFounder={profile.isFounder}
                latestAvatarPostId={profile.latestAvatarPostId}
                isOfficial={profile.isAdmin}
              />
            </div>
            {currentProfile ? (
              <div className="display-flex">
                <EditBtn />
                <LogoutBtn />
              </div>
            ) : profile.hasBlocked || profile.isBlockedBy ? (
              // Hide action buttons
              <div className="user-actions display-flex align-items-c profile-action-margin"></div>
            ) : (
              <div className="user-actions display-flex align-items-c profile-action-margin">
                <MessageBtn userId={profile._id} />
                <FollowBtn user={profile} />
              </div>
            )}
          </div>
          <h3>
            {profile.fname} {profile.lname}
          </h3>
          <small>@{profile.username}</small>
          <p className="word-wrap">{profile.bio}</p>

          <ul
            className=""
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              paddingLeft: "0",
              marginTop: "8px",
              marginBottom: "8px",
            }}
          >
            <li className="display-flex align-items-c">
              <MdLocationOn /> {[city, province].filter(Boolean).join(", ")}
            </li>
            <li className="display-flex align-items-c">
              <ImLink />
              <a href={profile.website}>{profile.website}</a>
            </li>
            <li className="display-flex align-items-c">
              <BsCalendar3 /> {t("joined")} {getDate(createdAt)}
            </li>
          </ul>
          <div className="profile-card__bio--follow display-flex">
            <p
              onClick={() => openUserSheet("following")}
              style={{ cursor: "pointer" }}
            >
              <span>{following.length}</span> {t("following")}
            </p>
            <p
              onClick={() => openUserSheet("followers")}
              style={{ cursor: "pointer" }}
            >
              <span>{followers.length}</span> {t("followers")}
            </p>
            <p
              onClick={() => openUserSheet("friends")}
              style={{ cursor: "pointer" }}
            >
              <span>{mutualFollowsLength}</span> {t("friends")}
            </p>
          </div>
          {currentUser?.isAdmin && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <IonButton
                color={profile.suspended ? "success" : "danger"}
                shape="round"
                onClick={() => dispatch(suspendVisitedProfile(username))}
              >
                {profile.suspended ? "Unsuspend" : "Suspend"}
              </IonButton>
              {/* NEW DELETE BUTTON */}
              <IonButton
                color="danger"
                fill="outline"
                shape="round"
                onClick={handleDeleteUser}
              >
                Delete User
              </IonButton>
            </div>
          )}
        </div>
      </div>
      <IonModal
        isOpen={openSheet}
        onDidDismiss={() => setOpenSheet(false)}
        initialBreakpoint={0.55}
        breakpoints={[0, 0.55, 0.8]}
        className="follow-sheet-modal"
      >
        <IonContent className="follow-sheet-content">
          <div className="follow-sheet">
            <div className="follow-sheet__grabber" />
            <h3>
              {sheetType === "followers"
                ? "Followers"
                : sheetType === "following"
                  ? "Following"
                  : "Friends"}
            </h3>

            <div className="follow-sheet__list">
              {sheetUsers.length === 0 ? (
                <div className="follow-sheet__empty">
                  <div className="follow-sheet__empty-icon">👀</div>
                  <p className="follow-sheet__empty-title">
                    No{" "}
                    {sheetType === "followers"
                      ? "followers"
                      : sheetType === "following"
                        ? "following"
                        : "friends"}{" "}
                    yet
                  </p>
                  <span className="follow-sheet__empty-sub">
                    {sheetType === "followers"
                      ? "When people follow this user, they’ll appear here."
                      : sheetType === "following"
                        ? "This user isn’t following anyone yet."
                        : "Mutual followers will appear here."}
                  </span>
                </div>
              ) : (
                sheetUsers.map((user) => (
                  <IonItem
                    key={user._id || user.username}
                    button
                    detail={false}
                    lines="none"
                    routerLink={`/profile/${user.username}`}
                    onClick={() => setOpenSheet(false)}
                    className="follow-sheet__item"
                  >
                    <div className="follow-sheet__user">
                      <div className="follow-sheet__avatar">
                        <Avatar
                          size="sm"
                          username={user.username}
                          avatar={user.avatar}
                          province={user.province}
                          isProfilePage={false}
                          isOfficial={user.isAdmin}
                        />
                      </div>

                      <div className="follow-sheet__meta">
                        <div className="follow-sheet__username">
                          @{user.username}
                        </div>
                      </div>

                      <div className="follow-sheet__chevron">›</div>
                    </div>
                  </IonItem>
                ))
              )}
            </div>
          </div>
        </IonContent>
      </IonModal>
    </>
  );
}

export default ProfileCard;
